/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ICartmanager contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum cartType {
    CLUB = 'CLUB',
    WINE = 'WINE'
}

export interface ICartmanagerConfig extends Msdyn365.IModuleConfig {
    cartType: cartType;
    redirectPage?: Msdyn365.ILinkData;
    refreshOnAction?: boolean;
}

export interface ICartmanagerProps<T> extends Msdyn365.IModule<T> {
    config: ICartmanagerConfig;
}
